import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.less";

const LineBreaks = ({ children, className }) => (
  <div className={`${styles.lineBreak} ${className}`}>{children}</div>
);

LineBreaks.defaultProps = {
  className: ""
};

LineBreaks.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element
  ]),
  className: PropTypes.string
};

export default LineBreaks;



// WEBPACK FOOTER //
// ./src/components/common/LineBreaks/LineBreaks.js